import {
  SET_INSIGHTS_ACTIVE_CHANNELS,
  SET_INSIGHTS_ACTIVE_MEMBERS,
  SET_INSIGHTS_ACTIVITY_COUNT,
  SET_INSIGHTS_AVERAGE_MEMBERS,
  SET_INSIGHTS_AVERAGE_REPLIES,
  SET_INSIGHTS_ENGAGEMENT_METRICS,
  SET_INSIGHTS_MESSAGES_DATA,
  SET_INSIGHTS_TTFR,
  SET_INSIGHTS_WEEKLY_MESSAGES,
} from "../actionType";

const initState = {
  active_members: [],
  average_members: [],
  active_channels: [],
  messages_data: [],
  engagement_metrics: {
    currentActive: "-",
    previousActive: "-",
    currentMessage: "-",
    previousMessage: "-",
    loading: true,
  },
  weekly_messages: [],
  average_replies: { results: [] },
  activity_count: [],
  ttfr: { results: [] },
};

const insightsReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_INSIGHTS_ACTIVE_MEMBERS:
      return {
        ...state,
        active_members: action.payload,
      };
    case SET_INSIGHTS_AVERAGE_MEMBERS:
      return {
        ...state,
        average_members: action.payload,
      };
    case SET_INSIGHTS_ACTIVE_CHANNELS:
      return {
        ...state,
        active_channels: action.payload,
      };
    case SET_INSIGHTS_MESSAGES_DATA:
      return {
        ...state,
        messages_data: action.payload,
      };
    case SET_INSIGHTS_ENGAGEMENT_METRICS:
      return {
        ...state,
        engagement_metrics: action.payload,
      };
    case SET_INSIGHTS_WEEKLY_MESSAGES:
      return {
        ...state,
        weekly_messages: action.payload,
      };
    case SET_INSIGHTS_AVERAGE_REPLIES:
      return {
        ...state,
        average_replies: action.payload,
      };
    case SET_INSIGHTS_ACTIVITY_COUNT:
      return {
        ...state,
        activity_count: action.payload,
      };
    case SET_INSIGHTS_TTFR:
      return {
        ...state,
        ttfr: action.payload,
      };

    default:
      return state;
  }
};

export default insightsReducer;
